import { useMemo } from 'react';
import { checkIsHoverDevice } from '@THC/utils/helpers';
export const useHasHoverSupport = () => {
    const hasHoverSupport = useMemo(() => checkIsHoverDevice(), []);
    return hasHoverSupport;
};
